module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "print-container"
  }, [_c('el-card', {
    staticClass: "print-card1"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Quick Print')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Quick Print Settings')) + ":")]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content2",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Select duration')) + ": ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeInterval),
      expression: "timeInterval"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeInterval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.timeIntervalChange]
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('One Week')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('One Month')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('One Quarter')))])])]), _vm._v(" "), _c('div', {
    staticClass: "content2"
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "25px"
    }
  }, [_vm._v(_vm._s(_vm.$t('End date')) + ":")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "cust",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.endDate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.timeChange]
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('Yesterday')))]), _vm._v(" "), _c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.time1),
      expression: "time1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Last Saturday')))]), _vm._v(" "), _c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.time1),
      expression: "time1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Last Sunday')))]), _vm._v(" "), _c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.time2),
      expression: "time2"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Last Day of Last Month')))]), _vm._v(" "), _c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.time3),
      expression: "time3"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Last Day of Last Quarter')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('Customize')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cust),
      expression: "cust"
    }],
    staticClass: "block cust"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.custDate,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.customizeDate
    },
    model: {
      value: (_vm.custTime),
      callback: function($$v) {
        _vm.custTime = $$v
      },
      expression: "custTime"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ":  "), _c('span', [_vm._v(_vm._s(_vm.timeRange))])])]), _vm._v(" "), _c('div', {
    staticClass: "content1 custn"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Week Filter')) + ":")]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "weeks",
    attrs: {
      "id": "weeks"
    }
  }, [_c('span', {
    staticClass: "tittle"
  }, [_c('label', {
    on: {
      "click": _vm.chooseAll
    }
  }, [_vm._v(_vm._s(_vm.$t('Weekdays')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Mon')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Tue')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Wed')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Thur')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Fri')))])])]), _vm._v(" "), _c('div', {
    staticClass: "weeks weken",
    attrs: {
      "id": "weken"
    }
  }, [_c('span', {
    staticClass: "tittle",
    class: {
      'de1': _vm.isDe, 'it1': _vm.isIt, 'po1': _vm.isPo, 'du1': _vm.isDu, 'fr1': _vm.isFr, 'sw1': _vm.isSw, 'cz5': _vm.isCz
    }
  }, [_c('label', {
    on: {
      "click": _vm.chooseAll
    }
  }, [_vm._v(_vm._s(_vm.$t('Weekends')))])]), _vm._v(" "), _c('span', {
    class: {
      'zh3': !_vm.isEn
    }
  }, [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Sat')))])]), _vm._v(" "), _c('span', {
    staticClass: "spe-span",
    class: {
      'zh4': !_vm.isEn, 'it2': _vm.isIt, 'po2': _vm.isPo, 'du2': _vm.isDu, 'fr2': _vm.isFr, 'sw2': _vm.isSw, 'cz2': _vm.isCz
    }
  }, [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Sun')))])])]), _vm._v(" "), _c('div', {
    staticClass: "content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Select reports to print')) + ":")]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "report"
  }, [_c('div', {
    staticClass: "content3"
  }, [_c('label', {
    on: {
      "click": _vm.chooseAll
    }
  }), _c('p', [_vm._v(_vm._s(_vm.$t('All')))]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "dash"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('dashboard')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value12),
      callback: function($$v) {
        _vm.value12 = $$v
      },
      expression: "value12"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value11),
      callback: function($$v) {
        _vm.value11 = $$v
      },
      expression: "value11"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "ds"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Daily Summary')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value12),
      callback: function($$v) {
        _vm.value12 = $$v
      },
      expression: "value12"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value11),
      callback: function($$v) {
        _vm.value11 = $$v
      },
      expression: "value11"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "dd"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Day By Day Overview')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value22),
      callback: function($$v) {
        _vm.value22 = $$v
      },
      expression: "value22"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value21),
      callback: function($$v) {
        _vm.value21 = $$v
      },
      expression: "value21"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "ol"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Sensor Overlay')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value32),
      callback: function($$v) {
        _vm.value32 = $$v
      },
      expression: "value32"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value31),
      callback: function($$v) {
        _vm.value31 = $$v
      },
      expression: "value31"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "ta"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Trend Analysis')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value42),
      callback: function($$v) {
        _vm.value42 = $$v
      },
      expression: "value42"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value41),
      callback: function($$v) {
        _vm.value41 = $$v
      },
      expression: "value41"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isM),
      expression: "!isM"
    }],
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "lg"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Logbook')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value52),
      callback: function($$v) {
        _vm.value52 = $$v
      },
      expression: "value52"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value51),
      callback: function($$v) {
        _vm.value51 = $$v
      },
      expression: "value51"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isM),
      expression: "!isM"
    }],
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "ev"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Event Summary')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value62),
      callback: function($$v) {
        _vm.value62 = $$v
      },
      expression: "value62"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value61),
      callback: function($$v) {
        _vm.value61 = $$v
      },
      expression: "value61"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evType),
      expression: "evType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.evType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('date')))]), _c('option', [_vm._v(_vm._s(_vm.$t('item')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "alert"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Alert')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value12),
      callback: function($$v) {
        _vm.value12 = $$v
      },
      expression: "value12"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value11),
      callback: function($$v) {
        _vm.value11 = $$v
      },
      expression: "value11"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isM),
      expression: "!isM"
    }],
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "dSet"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Device Settings Review')))]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })])]), _vm._v(" "), _c('button', {
    class: {
      'zh2': !_vm.isEn
    },
    on: {
      "click": _vm.print
    }
  }, [_vm._v(_vm._s(_vm.$t('createReport')))])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.typeChooseVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.typeChooseVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('setPeriod')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/cancel.png")
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "duration"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('duration')))]), _vm._v(" "), _c('select', {
    attrs: {
      "id": "duration"
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('7 days')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('14 days')))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('applyM')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-786c7f8d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print.vue
// module id = 1482
// module chunks = 7